<template>
  <ModalFormTemplate
    title="Denomination Count"
    width="50rem"
    end-point=""
    icon="money"
    :ignore-permission="true"
    @save="handleUpdate"
    mode="create"
    @close="$emit('close')"
  >
    <template #header-right>
      <Buttons
        caption="Update"
        icon="Save"
        type="success"
        @click="handleUpdate()"
        id="button-update"
      />
    </template>
    <template #form>
    <div class="space-y-4">
      <div class="p-4 overflow-y-auto flex-1">
    
          <div
            v-for="denom in denomationData?.denominations"
            :key="denom.id"
            class="grid md:grid-cols-3 gap-6"
          >
            <div class="font-medium text-gray-900 dark:text-white">
              {{ denom.name }} x {{ denom.multiply }}
            </div>
            <div class="flex-1">
              <NumberInput v-model="denom.count" placeholder="Enter Count" />
            </div>
            <div class="w-24 text-right text-gray-600 dark:text-gray-400">
              {{ formatNumber(denom.multiply * denom.count) }}
            </div>
          </div>
      <!-- Fixed Footer -->
      <div class="border-t border-gray-200 dark:border-gray-700 flex-shrink-0 mt-4">
        <!-- Total -->
        <div class="p-4 flex justify-between items-center bg-gray-50 dark:bg-gray-900">
          <span class="font-medium text-gray-900 dark:text-white">Total</span>
          <span class="text-xl font-bold text-gray-900 dark:text-white">
            {{ formatNumber(total) }}
          </span>
        </div>
        </div>
        </div>
    </div>
    </template>
  </ModalFormTemplate>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { formatNumber } from '../../../../../utils/CommonFunctions';
import ModalFormTemplate from '../../../../../components/ui/Templates/ModalFormTemplate.vue';
import { PaymentType } from '../../../../../types/models';
import Buttons from "../../../../../components/ui/form/Buttons.vue";
import NumberInput from "../../../../../components/ui/form/NumberInput.vue";

const props = defineProps<{
  paymentType: PaymentType | undefined
}>();

const emit = defineEmits<{
  (e: "update", total: number, float: PaymentType): void;
  (e: "close"): void;
}>();

const total = computed(() => {
  return props.paymentType?.denominations?.reduce((sum, denom) => {
    return sum + denom.multiply * denom.count;
  }, 0);
});

const denomationData = ref<PaymentType>();
onMounted(() => {
  if (props.paymentType) {
    denomationData.value = props.paymentType;
    denomationData.value?.denominations?.forEach((denom) => {
      denom.count = 0; // Initialize count to 0
    });
  }
});

const handleUpdate = () => {
  if (denomationData.value) {
    emit("update", total.value ?? 0, denomationData.value);
  }
  emit("close");
};
</script>
